document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('[data-news-article-content]');
  if (!content) return;

  const root =
    content.children.length === 1 && content.firstElementChild?.tagName === 'DIV'
      ? content.firstElementChild
      : content;

  const children = Array.from(root.children);
  if (children.length === 0) return;

  const isMediaBlock = (node) => {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
    const tagName = node.tagName;
    if (tagName === 'FIGURE' || tagName === 'VIDEO' || tagName === 'IFRAME') return true;
    if (tagName === 'P' && (node.querySelector('img') || node.querySelector('video') || node.querySelector('iframe'))) {
      return true;
    }
    return false;
  };

  const isCaptionCandidate = (node) => {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
    if (isMediaBlock(node)) return false;
    const tagName = node.tagName;
    if (tagName === 'FIGCAPTION') return true;
    if (tagName === 'P' || tagName === 'DIV' || tagName === 'SMALL') {
      const text = node.textContent.trim();
      if (!text) return false;
      const hasCaptionKeywords = /courtesy|photo:|photo by|photograph|installation view|collection|dimensions|oil on|acrylic|canvas|cm\b|inches\b|copyright|©/i.test(text);
      const isPureItalic = node.children.length === 1 && (node.firstElementChild.tagName === 'EM' || node.firstElementChild.tagName === 'I');
      const isShort = text.length <= 250;
      return hasCaptionKeywords || isPureItalic || isShort;
    }
    return false;
  };

  const flow = document.createElement('div');
  flow.className = 'news-article-flow';

  const processedItems = [];
  let i = 0;

  while (i < children.length) {
    const current = children[i];

    if (!isMediaBlock(current)) {
      processedItems.push({ type: 'text', element: current });
      i += 1;
      continue;
    }

    let figure = null;
    if (current.tagName === 'FIGURE') {
      figure = current;
      figure.classList.add('news-article-figure');
      const existingCaption = figure.querySelector('figcaption');
      if (existingCaption) {
        existingCaption.classList.add('news-article-caption');
      } else if (i + 1 < children.length && isCaptionCandidate(children[i + 1])) {
        const captionElem = document.createElement('figcaption');
        captionElem.className = 'news-article-caption';
        captionElem.innerHTML = children[i + 1].innerHTML;
        figure.appendChild(captionElem);
        i += 1;
      }
    } else {
      figure = document.createElement('figure');
      figure.className = 'news-article-figure';

      const mediaWrap = document.createElement('div');
      mediaWrap.className = 'news-article-figure__media';
      mediaWrap.appendChild(current);
      figure.appendChild(mediaWrap);

      if (i + 1 < children.length && isCaptionCandidate(children[i + 1])) {
        const captionElem = document.createElement('figcaption');
        captionElem.className = 'news-article-caption';
        captionElem.innerHTML = children[i + 1].innerHTML;
        figure.appendChild(captionElem);
        i += 1;
      }
    }

    processedItems.push({ type: 'media', element: figure });
    i += 1;
  }

  let j = 0;
  while (j < processedItems.length) {
    const item = processedItems[j];

    if (item.type === 'text') {
      flow.appendChild(item.element);
      j += 1;
      continue;
    }

    if (item.type === 'media') {
      if (j + 1 < processedItems.length && processedItems[j + 1].type === 'media') {
        const grid = document.createElement('div');
        grid.className = 'news-article-grid-2';
        grid.appendChild(item.element);
        grid.appendChild(processedItems[j + 1].element);
        flow.appendChild(grid);
        j += 2;
      } else {
        const singleWrap = document.createElement('div');
        singleWrap.className = 'news-article-single-media';
        singleWrap.appendChild(item.element);
        flow.appendChild(singleWrap);
        j += 1;
      }
    }
  }

  // Clear root and insert the restructured flow
  root.innerHTML = '';
  root.appendChild(flow);
});
